import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from 'react';
import { Box } from '@mantine/core';
import { getPosition, useSliderContext } from './slider';
interface IsMarkFilled {
  mark: {
    value: number;
    label?: any;
  };
  offset?: number;
  value?: number;
  inverted?: boolean;
}
export function isMarkFilled({
  mark,
  offset,
  value,
  inverted = false
}: IsMarkFilled) {
  return value != null && (inverted ? typeof offset === 'number' ? mark.value <= offset || mark.value >= value : mark.value >= value : typeof offset === 'number' ? mark.value >= offset && mark.value <= value : mark.value <= value);
}
export interface MarkCfg {
  value: number;
  label?: ReactNode;
  location?: 'top' | 'bottom';
  marker?: ReactNode;
}
export interface MarksProps {
  marks: MarkCfg[];
  min: number;
  max: number;
  value?: number;
  offset: number | undefined;
  disabled: boolean | undefined;
}
export function Marks(t0) {
  const $ = _c(17);
  const {
    marks,
    min,
    max,
    value,
    offset,
    disabled
  } = t0;
  const {
    getStyles
  } = useSliderContext();
  let t1;
  if ($[0] !== disabled || $[1] !== getStyles || $[2] !== marks || $[3] !== max || $[4] !== min || $[5] !== offset || $[6] !== value) {
    let t2;
    if ($[8] !== disabled || $[9] !== getStyles || $[10] !== max || $[11] !== min || $[12] !== offset || $[13] !== value) {
      t2 = (m, i) => <Box {...getStyles("markWrapper")} __vars={{
        "--mark-offset": `${getPosition({
          value: m.value,
          min,
          max
        })}%`
      }} key={i}><>{m.marker ? <div {...getStyles("markCustom")}>{m.marker}</div> : <Box {...getStyles("mark")} mod={{
            filled: isMarkFilled({
              mark: m,
              value,
              offset
            }),
            disabled
          }} />}{m.label != null && <div {...getStyles("markLabel")} style={{
            ...(m.location == "top" ? {
              bottom: "1.5rem"
            } : {
              top: "0.8rem"
            })
          }}>{m.label}</div>}</></Box>;
      $[8] = disabled;
      $[9] = getStyles;
      $[10] = max;
      $[11] = min;
      $[12] = offset;
      $[13] = value;
      $[14] = t2;
    } else {
      t2 = $[14];
    }
    t1 = marks.map(t2);
    $[0] = disabled;
    $[1] = getStyles;
    $[2] = marks;
    $[3] = max;
    $[4] = min;
    $[5] = offset;
    $[6] = value;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[15] !== t1) {
    t2 = <div>{t1}</div>;
    $[15] = t1;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  return t2;
}
Marks.displayName = '@mantine/core/SliderMarks';